(() => {
  'use strict';
  if (window.hellsinkiZedyCheckout) return;
  const configElement = document.getElementById('HellsinkiZedyCheckoutConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const overlay = document.querySelector('[data-zedy-overlay]');
  const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  const selectors = '[data-zedy-checkout], button[name="checkout"], input[name="checkout"], .cart__checkout, a.js-cart-btn-checkout';
  let busy = false;
  let disabledButtons = [];
  function rememberTracking() {
    const params = new URLSearchParams(location.search);
    trackingKeys.forEach(key => {
      if (!params.has(key)) return;
      try { sessionStorage.setItem('zedy_' + key, params.get(key)); } catch (_) {}
    });
  }
  function checkoutButton(target) {
    if (!(target instanceof Element)) return null;
    const button = target.closest(selectors);
    if (button) return button;
    const link = target.closest('a[href]');
    if (!link) return null;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:a\/)?checkouts?(?:\/|$)/i.test(url.pathname)) return link;
    } catch (_) {}
    return null;
  }
  function setLoading(active) {
    busy = active;
    if (overlay) overlay.hidden = !active;
    if (active) {
      document.querySelectorAll(selectors).forEach(button => {
        if (!('disabled' in button) || button.disabled) return;
        disabledButtons.push(button);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });
    } else {
      disabledButtons.forEach(button => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
      disabledButtons = [];
    }
  }
  function showError(trigger, message) {
    const container = trigger?.closest('.cart__checkout-wrapper') || trigger?.closest('form') || document.getElementById('MainContent');
    let status = container.querySelector('[data-zedy-error]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.zedyError = '';
      status.className = 'hellsinki-checkout-error';
      status.setAttribute('role', 'alert');
      status.tabIndex = -1;
      container.append(status);
    }
    status.textContent = message;
    status.hidden = false;
    status.focus();
  }
  function destination(value) {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== config.checkoutHost || url.username || url.password || (url.port && url.port !== '443')) throw new Error('Unexpected checkout destination');
    const params = new URLSearchParams(location.search);
    trackingKeys.forEach(key => {
      let value = params.get(key);
      if (!value) { try { value = sessionStorage.getItem('zedy_' + key); } catch (_) {} }
      if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    return url.href;
  }
  async function currentCart(form, signal) {
    const response = await fetch(config.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal });
    if (!response.ok) throw new Error('Cart unavailable');
    let cart = await response.json();
    const updates = {};
    form?.querySelectorAll('input[name="updates[]"][data-id]').forEach(input => {
      const item = cart.items.find(item => item.key === input.dataset.id);
      const quantity = Number(input.value);
      if (item && Number.isInteger(quantity) && quantity >= 0 && quantity !== item.quantity) updates[item.key] = quantity;
    });
    const note = form?.querySelector('[name="note"]');
    const changedNote = note && note.value !== (cart.note || '');
    if (Object.keys(updates).length || changedNote) {
      const payload = {};
      if (Object.keys(updates).length) payload.updates = updates;
      if (changedNote) payload.note = note.value;
      const updated = await fetch(config.cartUpdateUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), signal });
      if (!updated.ok) throw new Error('Cart update unavailable');
      cart = await updated.json();
    }
    return cart;
  }
  async function start(trigger) {
    if (busy) return;
    const form = trigger?.closest('form');
    const terms = form?.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) {
      terms.setCustomValidity(config.strings.terms);
      terms.reportValidity();
      terms.focus();
      terms.addEventListener('change', () => terms.setCustomValidity(''), { once: true });
      return;
    }
    document.querySelectorAll('[data-zedy-error]').forEach(status => { status.hidden = true; });
    rememberTracking();
    setLoading(true);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 35000);
    let navigating = false;
    try {
      const cart = await currentCart(form, controller.signal);
      if (!cart.item_count) {
        showError(trigger, config.strings.empty);
        return;
      }
      const payload = { ...cart, items: cart.items.map(item => ({ ...item, properties: Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => !key.startsWith('_hellsinki_'))) })) };
      const response = await fetch('https://app.zedy.com.br/api/public/shopify', { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shop: config.shop, origin: location.host, cart_payload: payload }), signal: controller.signal });
      if (!response.ok) throw new Error('Checkout unavailable');
      const checkout = await response.json();
      if (!checkout.active || typeof checkout.checkout_direct_url !== 'string') throw new Error('Checkout inactive');
      const url = destination(checkout.checkout_direct_url);
      location.assign(url);
      navigating = true;
    } catch (_) {
      showError(trigger, config.strings.error);
    } finally {
      clearTimeout(timeout);
      if (!navigating) setLoading(false);
    }
  }
  document.addEventListener('click', event => {
    const trigger = checkoutButton(event.target);
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    start(trigger);
  }, true);
  document.addEventListener('submit', event => {
    const trigger = checkoutButton(event.submitter || document.activeElement);
    if (!trigger || !(event.target instanceof HTMLFormElement)) return;
    let cartForm = event.target.id === 'CartPageForm' || event.target.id === 'CartDrawerForm';
    try { cartForm ||= new URL(event.target.action, location.href).pathname.replace(/\/$/, '') === config.cartPath.replace(/\/$/, ''); } catch (_) {}
    if (!cartForm) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    start(trigger);
  }, true);
  window.addEventListener('pageshow', () => setLoading(false));
  window.hellsinkiZedyCheckout = { start };
  rememberTracking();
})();
